import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import _ from 'lodash';
import { exportJsonToExcel, importExcel } from './Export2Excel';
export function formatJson(jsonData, filterVal) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}
/**
 * 导出数据到Excel文件
 * excel.js文档请参考:https://github.com/exceljs/exceljs/blob/3b261536dc81f0688480b04df920055ab4e2f488/README_zh.md
 * @param {Array[Object]} config.state sheet页是否隐藏，默认显示（visible：可见，hidden：隐藏）
 * @param {Array[Object]} config.data 需要导出的数据
 * @param {Array[String]} config.fields  需要导出到excel的属性名
 * @param {Array[String]} config.header 导出到excel后列标题的名称[['第一行第一列', '第一行第二列'],['第二行第一列']]
 * @param {Array[Object]} config.merges 需要合并的单元格,注意：计算row时要计算表头行数{row:0,col:0, rowspan: 1, colspan: 2}
 * @param {String} config.sheetName 需要生成的sheet的名称，默认Sheet+序号
 * @param {Object} config.domains 需要使用值域将值显示为描述的数据列 {field:[],field2:[]}
 * @param {Array[Object]} config.dataValidation 不推荐在config里面直接定义，考虑删除此配置，请在attrs里面定义数据验证 [{type:'', allBlank: true, formulae: ['"值1，值2，值3"'], row: 1, col: 1}]
 * @param {Object} config.protect 工作表保护 protect.password密码,protect.options保护选项
 * @param {Array[Object]} config.attrs 单元格属性[{rowStart:0,rowEnd:0,colStart:0,colEnd:0,attr: {fill: {type: 'pattern', pattern: 'darkVertical', bgColor: {{argb:'FF0000FF'}}}}}]
 * @param {String} fileName 生成的文件名称
 */
export function exportDataToExcel(config, fileName) {
  if (!config) return;
  const options = {
    fileName: fileName || `导出数据${new Date().toISOString()}.xlsx`,
    worksheets: []
  };
  if (!Array.isArray(config)) {
    config = [config];
  }
  config.forEach((item, index) => {
    const data = _.cloneDeep(item.data);
    if (item.domains) {
      const fields = Object.keys(item.domains);
      if (fields.length) {
        data.forEach(row => {
          fields.forEach(field => {
            if (row[field]) {
              const domain = item.domains[field].find(d => d.Code === row[field]);
              if (domain) {
                row[field] = item.domains[field].find(d => d.Code === row[field]).Text;
              }
            }
          });
        });
      }
    }
    const dataValidation = [];
    if (!_.isEmpty(item.dataValidation)) {
      item.dataValidation.forEach(validation => {
        let rowStart;
        let rowEnd;
        let colStart;
        let colEnd;
        if (validation.field) {
          rowStart = item.header.length + 1;
          rowEnd = item.header.length + item.data.length;
          colStart = item.fields.indexOf(validation.field) + 1;
          colEnd = colStart;
        } else {
          rowStart = validation.row + 1;
          rowEnd = validation.row + 1;
          colStart = validation.col + 1;
          colEnd = validation.col + 1;
        }
        const newValue = {
          showInputMessage: validation.showInputMessage || false,
          promptTitle: validation.promptTitle || '',
          prompt: validation.prompt || '',
          type: validation.type,
          operator: validation.operator,
          errorStyle: validation.errorStyle,
          errorTitle: validation.errorTitle,
          error: validation.error,
          showErrorMessage: validation.showErrorMessage || false,
          allBlank: validation.allBlank || true,
          formulae: _.isArray(validation.formulae) ? [`"${validation.formulae.join(',')}"`] : [`${validation.formulae}`],
          rowStart,
          rowEnd,
          colStart,
          colEnd
        };
        dataValidation.push(newValue);
      });
    }
    options.worksheets.push({
      state: item.state ? item.state : 'visible',
      data: [].concat(item.header).concat(formatJson(data, item.fields)),
      sheetName: item.sheetName || `Sheet${index + 1}`,
      merges: item.merges ? item.merges.map(o => [o.row + 1, o.col + 1, o.row + o.rowspan, o.col + o.colspan]) : undefined,
      dataValidation,
      protect: item.protect ? {
        password: item.protect.password,
        options: item.protect.options
      } : undefined,
      attrs: item.attrs ? item.attrs.map(cell => {
        const c = cell;
        if (c.field) {
          c.colStart = item.fields.indexOf(c.field);
        }
        c.rowStart += 1;
        c.rowEnd += 1;
        c.colStart += 1;
        c.colEnd += 1;
        return c;
      }) : undefined,
      columnsWidth: item.columnsWidth
    });
  });
  exportJsonToExcel(options);
}
/**
 * 从Excel中导入数据
 * @param {*} file 需要导入的文件
 * @param {Array|Object} options 每个sheet的解析配置，如果是Object，则为第一个sheet的配置，如果时数组，则为每个sheet的配置
 * @param {} options.startRow,endRow,startCol,endCol：读取数据的区域，如果为空，则从第一行第一列开始，到空行空列截至。
 * @param {Array} fields 从开始列到结束列需要映射数据的属性名
 * @param {Function({cellVal,columnIndex,rowIndex,cell,sheet,workbook})} optios.format 数据格式化
 * @param extParams 扩展参数 sheetsCount-解析sheet页数
 */
export function importExcelData(file, options, extParams) {
  return new Promise((resolve, reject) => {
    let configs = [];
    try {
      if (options && !Array.isArray(options)) {
        configs = [options];
      } else if (options) {
        configs = options;
      }
      importExcel(file).then(workbook => {
        const result = [];
        const worksheetsLength = extParams?.sheetsCount ? extParams.sheetsCount : workbook.worksheets.length;
        for (let s = 0; s < worksheetsLength; s += 1) {
          if (!configs.length || configs[s]) {
            const sheet = workbook.worksheets[s];
            const config = configs[s] || {};
            const rowStart = config.rowStart || 0;
            const rowEnd = config.rowEnd || sheet.rowCount - 1;
            const colStart = config.colStart || 0;
            const colEnd = config.colEnd || sheet.columnCount - 1;
            const sheetData = [];
            for (let r = rowStart; r <= rowEnd; r += 1) {
              const row = sheet.getRow(r + 1);
              const rowData = {};
              let isEmptyFlag = 0; // 用于处理没有数据空的行项目
              for (let c = colStart; c <= colEnd; c += 1) {
                const cell = row.getCell(c + 1);
                let cellValue = cell.value;
                let fieldName = cell._column.letter;
                if (config.fields && config.fields[c - colStart]) {
                  fieldName = config.fields[c - colStart];
                }
                if (config.format) {
                  cellValue = config.format({
                    cellValue,
                    columnIndex: c,
                    rowIndex: r,
                    cell,
                    sheet,
                    workbook,
                    rowData,
                    sheetData
                  });
                }
                if (_.isNil(cellValue)) {
                  isEmptyFlag++;
                }
                rowData[fieldName] = cellValue;
              }
              if (isEmptyFlag < sheet.columnCount) {
                sheetData.push(rowData);
              }
            }
            result.push(sheetData);
          }
        }
        resolve(result);
      });
    } catch (error) {
      reject(error);
    }
  });
}
export default {
  exportDataToExcel,
  formatJson,
  importExcelData
};